import React from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";

export function AddEditPlanDeEstudios(props) {
  const { onClose, onRefetch, planDeEstudio } = props;
  const { auth } = useAuth();
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear + 2; i >= 2000; i--) {
    years.push({ key: i, text: i, value: i });
  }

  const addPlan = async (data) => {
    try {
      await createPlanDeEstudioApi(data, auth.token);
      toast.success("Plan de estudio creado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  const updatePlan = async (id, data) => {
    try {
      await updatePlanDeEstudioApi(id, data, auth.token);
      toast.success("Plan de estudio actualizado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  async function createPlanDeEstudioApi(data, token) {
    try {
      const url = `${BASE_API}/api/plan_estudio/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.descripcion !== undefined) {
          toast.error("Ya existe ese plan de estudios");
        }
      }
      throw error;
    }
  }

  async function updatePlanDeEstudioApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/plan_estudio/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.descripcion !== undefined) {
          toast.error("Ya existe ese plan de estudios");
        }
      }
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(planDeEstudio),
    validationSchema: Yup.object(planDeEstudio ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue, { resetForm }) => {
      try {
        formValue.descripcion = `PLAN DE ESTUDIO ${formValue.descripcion}`;
        if (planDeEstudio) {
          await updatePlan(planDeEstudio.id_plane, formValue);
          onRefetch();
          onClose();
        } else {
          await addPlan(formValue);
          onRefetch();
          resetForm();
        }
      } catch (error) {
        resetForm();
        console.error(error);
      }
    },
  });

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <span className="astedisco">* </span>
        <label>PLAN DE ESTUDIO </label>
        <Dropdown
          name="descripcion"
          placeholder="Año plan de estudio"
          selection
          options={years}
          value={formik.values.descripcion}
          onChange={(e, { value }) =>
            formik.setFieldValue("descripcion", value)
          }
          error={formik.errors.descripcion}
        />
        <Button
          type="submit"
          content={planDeEstudio ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosPlan) {
  const lastPart = datosPlan?.descripcion
    ? datosPlan.descripcion.split(" ").pop()
    : " ";
  const year = parseInt(lastPart);
  return {
    descripcion: year || "",
  };
}

function newSchema() {
  return {
    descripcion: Yup.string().required(true),
  };
}
function updateSquema() {
  return {
    descripcion: Yup.string().required(true),
  };
}
